package io.eqoty.shared.datalayer.functions

import io.eqoty.shared.datalayer.Repository

suspend fun Repository.getWalletDisplayAddress(): String? = withRepoContext {
    return@withRepoContext web3Provider?.getActiveAccountAddress()
}